import type { JSX } from 'react';
import { useEcranEtroit } from './useEcranEtroit.js';
import type { PropsVue } from './types.js';
import type { VueCalendrier } from './periodes.js';
import { VueAnnee } from './VueAnnee.js';
import { VueMois } from './VueMois.js';
import { VueSemaine, VueSemaineCondensee } from './VueSemaine.js';

/**
 * Le corps d'un calendrier : semaine, mois ou année (la liste, propre à
 * chaque page, n'en fait pas partie). Un seul composant pour les expositions
 * et l'agenda : la page lui donne des `EvenementCalendrier` et ses actions,
 * il ne connaît ni l'une ni l'autre. Sur un écran étroit, la semaine devient
 * une liste de jours.
 */
export function Calendrier({
  vue,
  ...proprietes
}: PropsVue & { vue: Exclude<VueCalendrier, 'liste'> }): JSX.Element {
  const etroit = useEcranEtroit();
  if (vue === 'mois') return <VueMois {...proprietes} />;
  if (vue === 'annee') return <VueAnnee {...proprietes} />;
  return etroit ? <VueSemaineCondensee {...proprietes} /> : <VueSemaine {...proprietes} />;
}
